import {combineReducers} from 'redux';
import {contentSlice, ContentState} from './content';
import {faqSlice, FaqState} from './faq';
import {feedbackThemesSlice, FeedbackThemesState} from './feedbackThemes';

export interface ResourcesState {
  content: ContentState;
  faq: FaqState;
  feedbackThemes: FeedbackThemesState;
}

export const resources = combineReducers({
  content: contentSlice.reducer,
  faq: faqSlice.reducer,
  feedbackThemes: feedbackThemesSlice.reducer,
});
